<template>
  <v-form :value="valid" @input="v => $emit('update:valid', v)" ref="form">
    <v-row align="center" no-gutters>
      <j-date-picker
        :value="date"
        @input="v => $emit('update:date', v)"
        required
        filled
        class="no-before"
        label="Date"
        :disabled="disabled"
        icon=""
        inner-icon="fa-calendar"
      >
      </j-date-picker>
    </v-row>
    <v-row align="center" no-gutters>
      <v-autocomplete
        :items="getItems"
        item-value="id"
        item-text="nom"
        class="no-before"
        filled
        :value="fk_recipe"
        @change="v => $emit('update:fk_recipe', v)"
        label="Préparation"
        required
        :rules="[v => !!v || 'Veuillez sélectionner un produit']"
        :disabled="disabled"
      ></v-autocomplete>
    </v-row>
    <v-row align="center" no-gutters>
      <j-decimal-input
        :value="quantity"
        @input="v => $emit('update:quantity', v)"
        label="Quantité"
        class="no-before"
        filled
        :disabled="fk_recipe === null || disabled"
        :suffix="getUnit"
        hint="Laisser vide pour saisir lors de la production"
        persistentHint
      >
      </j-decimal-input>
    </v-row>
    <v-row align="center" no-gutters class="mt-3">
      <v-textarea
        auto-grow
        rounded
        :rows="2"
        label="Commentaires"
        filled
        dense
        class="no-before"
        hide-details
        :value="comments"
        @change="v => $emit('update:comments', v)"
      ></v-textarea>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "ScheduledPrepFields",
  props: {
    fk_recipe: {
      required: true
    },
    quantity: {
      required: true
    },
    date: {
      required: true
    },
    comments: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getRecipes"]),
    getItems() {
      return this.getRecipes.filter(x => x.est_intermediaire === true);
    },
    getUnit() {
      if (this.fk_recipe !== null) {
        const r = this.getRecipes.find(x => x.id === this.fk_recipe);
        if (r.data.use_conversion_formula) return r.data.unite_inventory;
        return r.unite_produite;
      }
      return "";
    }
  },
  methods: {
    reset() {
      this.$emit("update:date", moment().format("YYYY-MM-DD"));
      this.$emit("update:fk_recipe", null);
      this.$emit("update:quantity", null);
      this.$emit("update:comments", null);
    }
  }
};
</script>

<style></style>
